function convertRGBAToHexA(source) {
  const sep = source.includes(",") ? "," : " ";
  const openParenthesesIndex = source.indexOf("(") + 1;
  const valueAsString = source.slice(openParenthesesIndex, -1);
  const rgba = valueAsString.split(sep);
  if (rgba.includes("/")) rgba.splice(3, 1);
  let index = -1;
  for (const channel of rgba) {
    index++;
    if (channel.includes("%")) {
      const p = Number.parseInt(channel.slice(0, -1)) / 100;
      if (index < 3) {
        rgba[index] = Math.round(p * 255).toFixed();
      } else {
        rgba[index] = p.toFixed(3);
      }
    }
  }
  const r = Number.parseInt(rgba[0]).toString(16).padStart(2, "0");
  const g = Number.parseInt(rgba[1]).toString(16).padStart(2, "0");
  const b = Number.parseInt(rgba[2]).toString(16).padStart(2, "0");
  const output = `#${r}${g}${b}`;
  if (rgba.length > 3) {
    const a = Math.round(Number.parseFloat(rgba[3]) * 255).toString(16).padStart(2, "0");
    return `${output}${a}`;
  }
  return output;
}
import { validateTidalLicense } from "../../base/index.js";
validateTidalLicense();
export {
  convertRGBAToHexA
};
//# sourceMappingURL=convertRGBAToHexA.js.map
